<script>
    export let ctaClick;
    export let planName;
</script>

<div class="add-users-placeholder-wrapper">
    <div class="add-users-placeholder">
        <svg
            class="add-users-placeholder__icon"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor"
        >
            <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M19 7.5v3m0 0v3m0-3h3m-3 0h-3m-2.25-4.125a3.375 3.375 0 11-6.75 0 3.375 3.375 0 016.75 0zM4 19.235v-.11a6.375 6.375 0 0112.75 0v.109A12.318 12.318 0 0110.374 21c-2.331 0-4.512-.645-6.374-1.766z"
            />
        </svg>
        <span class="add-users-placeholder__text">Email address</span>
        <button class="add-users-placeholder__button" on:click={ctaClick}>
            Upgrade to <b class="add-users-placeholder__button__bold"
                >{planName}</b
            >
        </button>
    </div>
    <p class="add-users-placeholder-message">
        To add additional members, upgrade to <b
            class="add-users-placeholder-message__bold">{planName}</b
        > Plan
    </p>
</div>

<style>
    @import "../main.css";

    .add-users-placeholder-wrapper {
        @apply reset flex w-full flex-col items-stretch !important;
    }
    .add-users-placeholder {
        @apply reset mt-0 flex h-12 flex-row items-center gap-2 rounded-full border border-solid border-gray-200 bg-gray-100 py-2 pl-4 pr-2 text-gray-300 !important;
    }
    .add-users-placeholder__text {
        @apply reset text-sm text-gray-300 !important;
    }
    .add-users-placeholder__button {
        @apply reset ml-auto h-8 rounded-full bg-yellow-300 px-4 py-1 text-xs tracking-tight text-black transition-all hover:scale-105 hover:bg-yellow-400 !important;
    }
    .add-users-placeholder__button__bold {
        @apply reset text-xs font-bold tracking-tight text-inherit !important;
    }
    .add-users-placeholder__icon {
        @apply reset h-5 w-5 text-gray-300 !important;
    }
    .add-users-placeholder-message {
        @apply reset mt-1 text-center text-xs text-gray-300 hover:text-black !important;
    }
    .add-users-placeholder-message__bold {
        @apply reset text-xs font-bold text-inherit !important;
    }
</style>
